<template>
  <div class="companyPage" v-if="!this.showLoad">
    <div class="Header">
      <div class="logo ggMargin clearfix">
        <a href="javascript:void(0);" class="fl">
          <img :src="ImgSrc+'?x-oss-process=image/resize,m_fixed,w_45'" class="ggImg" alt />
        </a>
        <div class="logoMain fl">
          <p class="bigTit">{{companyOrgName}}</p>
          <p class="smallTit">{{companyBusinessScope}}</p>
        </div>
      </div>

      <div class="baseIntro">
        <p class="mainTit">基本信息</p>
        <ul>
          <li>
            <em class="logoIcon">
              <img :src="baseUrl+'img/company/topIcon01.png'" class="ggImg" alt />
            </em>
            <span>地址：{{companyAddress}}</span>
          </li>
          <li>
            <em class="logoIcon">
              <img :src="baseUrl+'img/company/topIcon02.png'" class="ggImg" alt />
            </em>
            <span>
              电话：
              <a href="javascript:void(0);" @click="telPhone(companyPhone)">{{companyPhone}}</a>
            </span>
          </li>
          <li v-if="this.companyInternet!=null">
            <em class="logoIcon">
              <img :src="baseUrl+'img/company/topIcon03.png'" class="ggImg" alt />
            </em>
            <span>
              官网：{{companyInternet}} 
            </span>
          </li>
          <li>
            <em class="logoIcon">
              <img :src="baseUrl+'img/company/topIcon04.png'" class="ggImg" alt />
            </em>
            <span>统一社会信用代码：{{companyIicenseNumber}}</span>
          </li>
        </ul>
      </div>
    </div>
    <p class="baseLine"></p>
    <div class="intro">
      <p class="mainTit">公司介绍</p>
      <p class="count" v-html="conpanyCount"></p>
    </div>
    <p class="baseLine"></p>
    <div class="permit">
      <p class="mainTit">营业执照</p>
      <div class="Img">
        <img :src="conpanyBusinessLicense" class="ggImg" alt />
      </div>
    </div>
    <p class="baseLine"></p>
    <div class="permitBox">
      <p class="mainTit">资质</p>
      <div class="treeHomeDetail" v-if="this.discoverImg != ''">
        <van-swipe @change="onChangeTreeHome" class="swiperTreeHome">
          <van-swipe-item
            v-for="(item,index) in discoverImg"
            :key="index"
            class="swiperTreeHomeItem"
          >
            <div class="TreeHomeImg">
              <img
                v-if="item != null"
                @error="imgError(item)"
                @click="magnifyImg(index)"
                :src="item ? item  : ''+'?x-oss-process=image/resize,h_178)no-repeat center cover'"
                alt
              />
            </div>
          </van-swipe-item>
          <div
            class="custom-indicator"
            slot="indicator"
            v-if="this.discoverImg != ''"
          >{{ TreeHomeCurrent + 1 }}/{{this.discoverImg ? this.discoverImg.length : ''}}</div>
        </van-swipe>
      </div>
    </div>
    <!-- 放大图片组件 -->
    <van-image-preview
      v-model="magnifyImgShow"
      :images="magnifyImgList"
      class="magnifyImg"
      :start-position="magnifyImgListIndex"
    />
    <refresh-page v-if="refreshPage" />
  </div>
   <!-- /*eslint-disable*/ -->
</template>
<script>
/* eslint-disable */
import { mapState, mapMutations } from "vuex";
const refreshPage = () => import("@/components/common/refreshPage");
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  /*eslint-disable*/
  name: "companyMsg",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      TreeHomeCurrent: 0, //古树之家轮播list
      magnifyImgShow: false, //默认不显示
      magnifyImgList: [], //放大图片list
      magnifyImgListIndex: 0, //放大图片下标
      discoverImg: [], //资质
      companyOrgName: "", //公司名称
      ImgSrc: "", //公司Logo
      companyAddress: "", //公司地址
      companyBusinessScope: "", //公司业务范围
      companyPhone: "", //公司号码
      companyInternet: "", //公司官网地址
      companyIicenseNumber: "", //公司信用代码
      conpanyCount: "", //公司简介
      conpanyBusinessLicense: "", //营业执照
       refreshPage: false, // 网络请求失败时显示
      clientType: getDeviceType() //手机类型
    };
  },
  created() {
    document.title = "公司信息"; //设置title的值。
  },
  mounted() {
    this.initPage();
  },
  components:{
    refreshPage
  },
  methods: {
     ...mapMutations(["setShowLoad"]),
    initPage() {
      
      let _this = this;
      _this.$api.baseCommon.baseMsg.company
        .Detail()
        .then(res => {
          if (res.code == "1") {
            _this.companyOrgName = res.data.orgName;
            _this.ImgSrc = res.data.logo;
            _this.companyAddress = res.data.officeAddress;
            _this.companyPhone = res.data.contact;
            _this.companyInternet = res.data.website;
            _this.companyIicenseNumber = res.data.licenseNumber;
            _this.companyBusinessScope = res.data.vision;
            _this.conpanyCount = res.data.businessScope;
            _this.conpanyBusinessLicense = res.data.businessLicense;
             _this.discoverImg = res.data.certificatePhotos;
              this.setShowLoad(false); //加载状态，默认为true加载
          } else {
               if (_this.clientType == "android") {
              //安卓
              window.android.getInfo(103, "1");
            } else {
              //IOS
              window.webkit.messageHandlers.closePage.postMessage("1");
            }
          }
        })
        .catch(err => {
          console.log(err);
           this.setShowLoad(false); //加载状态，默认为true加载
          //  _this.refreshPage = true;
        });
    },
 imgError(item) {
      //图片地址失效
      item.url = this.baseUrl+'img/group.png';
    },
    onChangeTreeHome(index) {
      this.TreeHomeCurrent = index;
    },
    //放大图片
    magnifyImg(itemLength) {
      let magnifyList = [];
      this.magnifyImgListIndex = parseInt(itemLength);
      this.discoverImg.forEach(SelectBigImgs);
      function SelectBigImgs(item, index) {
        magnifyList.push(item);
      }
      this.magnifyImgList = magnifyList;
      this.magnifyImgShow = true;
    },
    telPhone(phone){ //拨打电话
       if (this.clientType == "android") {
        window.android.getInfo(111,phone);
      } else {
        //IOS
       window.webkit.messageHandlers.getPhone.postMessage(String(phone));
      }
    },
    jumpUrl(url){ //跳转路由
      if (this.clientType == "android") {
        window.android.getInfo(112,url);
      } else {
        //IOS
        window.webkit.messageHandlers.getJumpUrl.postMessage(url);
      }
    }
  },
   computed: {
    ...mapState(["showLoad", "userinfo"])
  },
};
</script>
<style lang="less">
.companyPage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .ggMargin {
    width: 100%;
    padding: 0 12px;
  }
  .ggImg {
    max-width: 100%;
  }
  .mainTit {
    font-size: 16px;
    font-family: "PingFangSC-Medium", "PingFang SC";
    font-weight: 600;
    color: #000;
    line-height: 22px;
    margin-bottom: 15px;
  }
  .baseLine {
    width: 100%;
    height: 12px;
    background-color: #f5f6f8;
  }
  .Header {
    div.logo {
      width: 100%;
      min-height: 95px;
      background-color: #3c78f9;
      position: relative;
      padding-top: 25px;
      padding-bottom: 8px;
      a {
        display: inline-block;
        width: 45px;
        height: 45px;
        margin-left: 17px;
        img {
          max-width: 100%;
        }
      }
      .logoMain {
        width: calc(100% - 70px);
        display: inline-block;
        margin-left: 8px;
      }
      p {
        display: inline-block;
        color: #fff;
        font-size: 18px;
      }

      p.smallTit {
        text-indent: 2em;
        font-size: 12px;
        margin-top: 5px;
        line-height: 17px;
        opacity: 0.8;
      }
    }
    .baseIntro {
      background-color: #fff;
      padding: 10px 12px 17px;
      ul {
        li {
          margin-bottom: 10px;
          .logoIcon {
            display: inline-block;
            width: 14px;
            height: 14px;
            margin-right: 12px;
          }
          span {
            font-size: 14px;
            font-weight: 400;
            color: #8d98b1;
            line-height: 20px;
            a {
              color: #3c78f9;
            }
          }
        }
      }
    }
  }
  .intro {
    padding: 10px 12px 17px;

    .count {
      text-indent: 2em;
      font-size: 14px;
      font-family: "PingFangSC-Regular", "PingFang SC";
      font-weight: 400;
      color: #8d98b1;
      line-height: 24px;
    }
  }
  .permit {
    padding: 10px 12px;
    .Img {
      width: 100%;
    }
  }
  .permitBox {
    padding: 10px 12px;
    .treeHomeDetail {
      width: 100%;
      height: 230px;
      overflow: hidden;
      text-indent: initial;
      padding: 0;
      margin-top: 10px;
      padding-top: 10px;
      //   border-top: 1px solid #f6f6f6;
    }
    .swiperTreeHome {
      width: 100%;
      height: 210px;
      position: relative;
      .swiperTreeHomeItem {
        .TreeHomeImg {
          width: 100%;
          height: 100%;
          text-align: center;
          position: relative;
          overflow: hidden;
          img {
            position: absolute;
            max-width: 100%;
            max-height: 100%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
        .removeImg {
          display: block;
          position: absolute;
          top: 0;
          right: 5px;
          width: 20px;
          height: 20px;
          border: 1px solid #f6f6f6;
          text-align: center;
          color: red;
          font-size: 12px;
          line-height: 20px;
          border-radius: 50%;
          -webkit-border-radius: 50%;
          -moz-border-radius: 50%;
        }
      }
      .custom-indicator {
        position: absolute;
        width: 40px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        text-align: center;
        // padding-right: 40px;
        right: 0;
        bottom: 0;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.3);
      }
    }
  }
}
</style>